export { type IconProps, default as Icon } from './Icon';
